import { useState } from 'react';
import { useSnackbarContext } from '@ui-lib/components/Snackbar/SnackbarProvider';
import { useModal } from '@web-shared/hooks';
import useManualRequest from '@web-shared/hooks/useManualRequest';
import HttpError from '@web-shared/services/http-service/HttpError';
import { PHOTO_TYPE } from '../../../api/types/PhotoType';

import { uploadPodImage } from '../../../api';

export const useAddPhoto = (setPhoto: (photo: string) => void, photoType: PHOTO_TYPE) => {
  const [open, handleModalStateChange] = useModal();
  const [cameraError, setCameraError] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const http = useManualRequest(uploadPodImage);
  const { showErrorSnackbar } = useSnackbarContext();

  const savePhoto = async (token: string, imageSrc: string) => {
    setLoading(true);
    try {
      await http.trigger({ token: token, picture: imageSrc, photo_type: photoType });
      setPhoto(imageSrc);
    } catch (error) {
      if (HttpError.isHttpError(error)) {
        showErrorSnackbar({ message: error.message });
      }
    } finally {
      setLoading(false);
    }
  };

  return {
    open,
    handleModalStateChange,
    cameraError,
    setCameraError,
    loading,
    savePhoto,
    openCamera: handleModalStateChange,
  };
};
